import styled from 'styled-components'
import { themeGet } from 'styled-system'

const breakpoints = {
  belowTablet: '@media (max-width: 650px)',
}

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: ${themeGet('spacing.redTurquoise60_3_75rem')};
  padding-top: ${themeGet('spacing.redTurquoise60_3_75rem')};
  padding-left: ${themeGet('spacing.turquoise20_1_25rem')};
  padding-right: ${themeGet('spacing.turquoise20_1_25rem')};
  background-color: #2d6a6e;
  background-image: url(${themeGet('banners.landingBackgroundImage')});
  background-position: ${themeGet('banners.landingBackgroundImageAlignment') ??
    'center'};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
  color: white;
  overflow: hidden;
`

export const WaveBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #3d8c91 0%, transparent 50%);
  opacity: 0.3;

  &::before {
    content: '';
    position: absolute;
    top: 20%;
    right: 10%;
    width: 200px;
    height: 200px;
    background: #3d8c91;
    border-radius: 50%;
    opacity: 0.2;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 30%;
    left: 5%;
    width: 150px;
    height: 150px;
    background: #3d8c91;
    border-radius: 50%;
    opacity: 0.15;
  }
`

export const NavigationBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: ${themeGet('breakpoints.sizes.large')};

  ${themeGet('breakpoints.mobileLarge')} {
    padding: 1rem;
  }
`

export const BackLinkWrapper = styled.div`
  a {
    color: white;
    text-decoration: none;
    font-size: 0.875rem;
    font-weight: 400;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const SiteSelectorWrapper = styled.div`
  display: flex;
  align-items: center;

  div {
    color: white;
    border-bottom: 1px solid transparent;
    border-top: 1px solid transparent;

    &:hover {
      border-bottom: 1px solid white;
      color: white;
    }

    &:focus {
      border-bottom: 1px solid white;
      color: white;
    }
  }
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: ${themeGet('breakpoints.sizes.large')};
  padding: 0 ${themeGet('spacing.turquoise20_1_25rem')};
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  text-align: left;

  ${themeGet('breakpoints.mobileLarge')} {
    padding: 0;
    align-items: flex-start;
  }

  ${themeGet('breakpoints.mobile')} {
    padding: 0;
  }
`

export const TierPill = styled.div`
  margin-bottom: 1.5rem;

  span {
    background: #e5e5e5 !important;
    color: #2d6a6e !important;
    font-weight: 600;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    padding: 0.375rem 1rem;
    border-radius: 6.25rem;
  }
`

export const Title = styled.h1`
  font-size: ${themeGet('banners.headerTextSize', '2.5rem')};
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 0.5rem 0;
  color: white;
  text-align: left;
  font-family: ${themeGet('banners.headerTextFont')};

  ${themeGet('breakpoints.mobileLarge')} {
    font-size: 2rem;
  }
`

export const ProgressText = styled.p`
  font-size: 1rem;
  font-weight: 400;
  margin: 0 0 1.5rem 0;
  color: white;
  opacity: 0.9;
  text-align: left;
`

export const Description = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 2rem 0;
  color: white;
  max-width: 60%;
  opacity: 0.9;
  text-align: left;

  ${breakpoints.belowTablet} {
    max-width: 75%;
    font-size: ${themeGet('spacing.blue16_1rem')};
  }

  ${themeGet('breakpoints.mobileLarge')} {
    max-width: 100%;
    text-align: left;
  }
`

export const TabNavigation = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 2rem;
  padding-top: 1.5rem;
  width: 100%;

  ${themeGet('breakpoints.mobileLarge')} {
    gap: 1rem;
    flex-wrap: wrap;
  }
`

export const TabButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 0;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  ${({ isActive }) =>
    isActive &&
    `
    font-weight: 600;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -0.25rem;
      left: 0;
      right: 0;
      height: 3px;
      background: white;
      border-radius: 2px;
    }
  `}
`
